import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../Helper/Context";
import moment from "moment";
import useFetch from "./useFetch";

const Enrolment = () => {
  const { setShowNotifcationLogin, mainState, setMainState, setShowLoader, resetState } = useContext(ThemeContext);
  window.scrollTo(0, 0);
  const [{ response }, dofetch] = useFetch();
  const [apiErrors, setApiErrors] = useState(true);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [apiName, setApiName] = useState("getuser");
  console.log(mainState);
  const handleBackToHome = (e) => {
    // setMainState({...mainState,
    //     section:'landing',
    //     isLoggedIn:false
    // })
    // setShowNotifcationLogin(false);
    // window.location.reload();
    if (localStorage.getItem("parentDetails")) {
      let ParentDetails = JSON.parse(localStorage.getItem("parentDetails"));
      console.log(ParentDetails);
      localStorage.removeItem("parentDetails");
      setMainState(ParentDetails);
      // console.log(ParentDetails);
    } else {
      console.log(resetState);
      setMainState(resetState);
      localStorage.removeItem("parentDetails");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("childDetails")) {
      if (apiName === "getuser") {
        if (response) {
          // setNoOfPaymentSource(response.value.paymentSources.length);
          // setApiName('enrolluser')
          setShowLoader(false);
          let ParentDetails = JSON.parse(localStorage.getItem("parentDetails"));
          let OldNoOfPyamentSources = ParentDetails.user.paymentSources.length;
          let NewNoOfPyamentSources = response.value[0].paymentSources.length;

          if (NewNoOfPyamentSources > OldNoOfPyamentSources && NewNoOfPyamentSources > 1) {
            if (localStorage.getItem("childDetails")) {
              console.log("called to enroll in enrollment and get user");

              let enrollmentData = {
                memberId: mainState.bookedSlot.selectedChild.id,
                groupId: mainState.bookedSlot.groupId,
                startDate: mainState.bookedSlot.startDate.split('T')[0],
                // endDate: mainState.bookedSlot.endDate,
                endDate: null,
                forceEnrollment: true,
                enrollmentOptionId: 2,
                setRequiredActivityLevel: true,
                notifyMember: true,
              };

              ParentDetails.user.paymentSources = response.value[0].paymentSources;
              localStorage.setItem("parentDetails", JSON.stringify(ParentDetails));
              setApiName("enrolluser");
              setApiErrors(false);
              dofetch(mainState.fetchURL, "EnrollMemberToGroup", "EnrollMemberToGroup.post.odata", "", JSON.stringify(enrollmentData));
            }
            // setApiName('enrolluser');
          } else {
            setApiErrors("Payment failed, Please try again");
            localStorage.removeItem("childDetails");
          }

          console.log(OldNoOfPyamentSources);
          console.log(NewNoOfPyamentSources);
        } else {
          let ParentDetails = JSON.parse(localStorage.getItem("parentDetails"));
          let urlParams = "?$filter=email eq '" + ParentDetails.user.email + "' and isDeleted eq false&$expand=paymentSources,address";
          dofetch(mainState.fetchURL, "GetMembers", "info.get.odata", urlParams, "");
        }
      }
      if (apiName === "enrolluser") {
        if (response) {
          if (response.errors) {
            console.log(response.errors);
            setApiErrors(response.errors[0].message);
            setShowLoader(false);
            localStorage.removeItem("childDetails");
          } else {
            if (response?.contractId) {
              console.log("called to enroll in enrollment");
              console.log("enroll User", response);
              const updatedPaymentSources = JSON.parse(localStorage.getItem("parentDetails")).user.paymentSources;
              console.log("payment sources", updatedPaymentSources);

              const postData = {
                memberPaymentSourceId: parseInt(updatedPaymentSources[updatedPaymentSources.length - 1].id),
                contractsIds: [response.contractId],
              };
              console.log("post data", postData);
              let myHeaders = new Headers();
              myHeaders.append("Content-Type", "application/json");
              myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");
              dofetch(mainState.fetchURL, "AssignPaymentSource", "AssignPaymentSource.post.odata", "", JSON.stringify(postData), true);
              setApiErrors(false);
              setShowLoader(false);
              localStorage.removeItem("childDetails");
            }
          }
        }
      }
    } else {
      setApiErrors(false);
    }
    setShowLoader(false);
  }, [response, apiName]);

  return (
    <div className="enrolment-details">
      {apiErrors ? (
        <>
          <p className="Error">{apiErrors}</p>
        </>
      ) : (
        <>
          <h2>Your enrolment is complete</h2>
          <p>
            Your enrolment for <strong>{mainState.bookedSlot.selectedChild.firstName + " " + mainState.bookedSlot.selectedChild.lastName}</strong> is
            now complete.
          </p>
          <p>
            <strong>Here are your class details:</strong>
          </p>

          <div className="enrolment-details-wrapper">
            <ul>
              <li>
                <div className="type">Student</div>
                <div className="details">{mainState.bookedSlot.selectedChild.firstName + " " + mainState.bookedSlot.selectedChild.lastName}</div>
              </li>
              <li>
                <div className="type">Level</div>
                <div className="details">{mainState.bookedSlot.activityMemberLevel.name}</div>
              </li>
              <li>
                <div className="type">Instructor</div>
                <div className="details">{mainState.bookedSlot.instructor.firstName + " " + mainState.bookedSlot.instructor.lastName}</div>
              </li>
              <li>
                <div className="type">First Class</div>
                <div className="details">
                  <strong>{moment(mainState.bookedSlot.startDate).format("dddd")}</strong>{" "}
                  {moment(mainState.bookedSlot.startDate).format("DD MMMM YYYY")}
                </div>
              </li>
              <li>
                <div className="type">Zone</div>
                <div className="details">{mainState.bookedSlot.clubId}</div>
              </li>
            </ul>
          </div>
          <p>
            For your first lesson, please allow at least 10 minutes before the start of class to pick up your member + spectator swipe cards from
            reception.
          </p>
        </>
      )}
      <p>
        If you have any questions, please contact us on 9411 3344 or on{" "}
        <a className="link" href="mailto:swim@cockburnarc.com.au">
          swim@cockburnarc.com.au
        </a>
      </p>

      <button className="btn btn-border btn-wide" onClick={(e) => handleBackToHome()}>
        <i className="far fa-arrow-left"></i>back to home
      </button>
    </div>
  );
};

export default Enrolment;
